import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'app-modal-massive-update',
    styleUrls: ['./modal-massive-update.style.scss'],
    templateUrl: './modal-massive-update.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalMassiveUpdateComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formMassiveUpdate: FormGroup;
    /**Retorno a pantalla padre */
    public onClose: Subject<boolean>;

    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder) {
    }
    ngOnInit(): void {
        this.onClose = new Subject();
        this.initializeFormMassiveUpdate();
    }
    private initializeFormMassiveUpdate() {
        this.formMassiveUpdate = this.formBuilder.group({
            isMassive: [null, [Validators.required]]
        });
    }
    private submit(): void {
        if (this.formMassiveUpdate.valid) {
            let value = this.formMassiveUpdate.value.isMassive;
            this.onClose.next(value);
            this.bsModalRef.hide();
        }
    }
    
    private onCancel(): void {
        this.onClose.next(null);
        this.bsModalRef.hide();
    }
}
